import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getDeviceOnlineStatus, DeviceOnlineStatusResponse } from '../../services/DeviceService';

function useDeviceOnlineStatus(
  fleetId: string | null,
  deviceId: string | null,
  enabled: boolean = true,
  refetchInterval: number | false = false,
): UseQueryResult<DeviceOnlineStatusResponse> {
  const shouldRun = Boolean(fleetId && deviceId && enabled);

  return useQuery(
    ['device-online-status', fleetId ?? '', deviceId ?? ''],
    (): Promise<DeviceOnlineStatusResponse> => getDeviceOnlineStatus(fleetId as string, deviceId as string),
    {
      enabled: shouldRun,
      retry: 1,
      staleTime: 30 * 1000,
      refetchInterval,
    },
  );
}

export default useDeviceOnlineStatus;
